<template>
    <div>
        <v-row no-gutters>
            <v-col cols="6">
                <h1 class="headline font-weight-light">Receive Part</h1>
            </v-col>

            <v-col cols="6" class="text-right">
                <v-btn rounded small class="ml-5" @click="get_history()">
                    <v-icon small class="mr-1"> mdi-magnify </v-icon>
                    History
                </v-btn>

                <v-btn
                    v-if="checkbox.length > 0"
                    color="success"
                    class="ml-1"
                    small
                    rounded
                    @click="get_dialog_part(actibe_tab)"
                >
                    <v-icon small class="mr-1">mdi-content-save</v-icon>
                    Save Receive : {{ checkbox.length }} Part</v-btn
                >
                <v-btn
                    v-if="checkboxnonhp.length > 0"
                    color="success"
                    class="ml-1"
                    small
                    rounded
                    @click="get_dialog_part(actibe_tab)"
                >
                    <v-icon small class="mr-1">mdi-content-save</v-icon>
                    Save Receive : {{ checkboxnonhp.length }} part</v-btn
                >
            </v-col>
        </v-row>

        <!-- Search -->
        <v-row>
            <v-col cols="11" sm="5" md="4" class="mar-t-10">
                <v-text-field
                    label="Search"
                    dense
                    v-model="textsearch"
                    @keyup="change_search($event.target.value)"
                ></v-text-field>
                <!-- @input="change_search" -->
                <!-- @paste="onPaste" -->
            </v-col>
            <v-col cols="1">
                <v-btn
                    x-small
                    fab
                    class="mr-1"
                    v-if="textsearch != ''"
                    @click="reset()"
                >
                    <v-icon>mdi-rotate-left</v-icon></v-btn
                >
            </v-col>
            <BarcodeReader @barcode="gen_barcode" :direction="direction" />
        </v-row>

        <div class="mar-t-10 no-pd">
            <v-tabs
                v-model="tab"
                background-color="blue accent-2"
                color="lime accent-2"
                class="elevation-2"
                dark
                :grow="true"
            >
                <v-tabs-slider></v-tabs-slider>

                <v-tab
                    v-for="i in tabs_name.length"
                    :key="i"
                    :href="`#tab-${i}`"
                    @click="change_tab(tabs_name[i - 1])"
                >
                    <v-icon class="mr-1" v-if="tabs_name[i - 1] === actibe_tab"
                        >mdi-checkbox-marked-circle</v-icon
                    >
                    {{ tabs_name[i - 1] }}
                </v-tab>
                <v-tabs-items touchless v-model="tab">
                    <v-tab-item
                        v-for="i in tabs_name.length"
                        :key="i"
                        :value="'tab-' + i"
                    >
                        <div v-if="i === 1">
                            <v-row
                                v-for="(r, i) in data_main"
                                :key="i"
                                class="mt-3"
                            >
                                <v-chip class="amber ml-5">{{
                                    r.project_name
                                }}</v-chip>
                                <v-col cols="12">
                                    <v-simple-table class="table-inv">
                                        <template v-slot:default>
                                            <thead>
                                                <tr class="col-tr-1">
                                                    <th
                                                        class="text-center"
                                                    ></th>
                                                    <th class="text-center">
                                                        #
                                                    </th>
                                                    <th class="text-center">
                                                        LMT
                                                    </th>
                                                    <th class="text-center">
                                                        Case ID
                                                    </th>
                                                    <th class="text-center">
                                                        Dete Open
                                                    </th>
                                                    <th class="text-center">
                                                        PO Number
                                                    </th>
                                                    <th class="text-center">
                                                        Part
                                                    </th>
                                                    <th class="text-center">
                                                        RMA
                                                    </th>

                                                    <th class="text-center">
                                                        Site Name
                                                    </th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr
                                                    v-for="(row,
                                                    index) in r.parts"
                                                    :key="index"
                                                >
                                                    <td class="text-center">
                                                        <v-checkbox
                                                            v-model="checkbox"
                                                            label=""
                                                            color="green"
                                                            :value="row"
                                                            @change="
                                                                open_dialog_ct(
                                                                    row.part_issue_id,
                                                                    row.project_name,
                                                                    row.product_group,
                                                                    row.product_line
                                                                )
                                                            "
                                                        ></v-checkbox>
                                                    </td>
                                                    <td class="text-center">
                                                        {{ index + 1 }}.
                                                    </td>
                                                    <td class="text-center">
                                                        {{ row.ship_date }}
                                                    </td>
                                                    <td class="text-center">
                                                        <v-chip
                                                            x-small
                                                            class="amber"
                                                            >{{
                                                                row.case_id +
                                                                    "-" +
                                                                    row.subcase
                                                            }}</v-chip
                                                        >
                                                        <br />
                                                        <v-chip
                                                            x-small
                                                            :color="
                                                                row.case_type !=
                                                                'Onsite Repair'
                                                                    ? 'primary'
                                                                    : ''
                                                            "
                                                            >{{
                                                                row.case_type
                                                            }}</v-chip
                                                        >
                                                    </td>
                                                    <td class="text-center">
                                                        {{ row.created_date }}
                                                    </td>
                                                    <td class="text-center">
                                                        {{ row.ponumber }}
                                                    </td>
                                                    <td class="text-center">
                                                        {{ row.part_name }}
                                                    </td>
                                                    <td class="text-center">
                                                        {{ row.rma }}
                                                    </td>

                                                    <td>
                                                        {{ row.site_name }}
                                                        <br />
                                                        <v-chip
                                                            color="orange darken-4"
                                                            text-color="white"
                                                            x-small
                                                            v-if="
                                                                row.site_district_id
                                                            "
                                                        >
                                                            {{
                                                                row.site_district_id
                                                            }}</v-chip
                                                        >
                                                        <v-chip
                                                            class="ml-1 mr-1"
                                                            color="pink"
                                                            text-color="white"
                                                            x-small
                                                            v-if="
                                                                row.site_amphur_id
                                                            "
                                                        >
                                                            {{
                                                                row.site_amphur_id
                                                            }}</v-chip
                                                        >
                                                        <v-chip
                                                            color="purple darken-2"
                                                            text-color="white"
                                                            x-small
                                                            v-if="
                                                                row.site_province_id
                                                            "
                                                        >
                                                            {{
                                                                row.site_province_id
                                                            }}</v-chip
                                                        >
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </template>
                                    </v-simple-table>
                                    <hr class="fix-hr-1" />
                                </v-col>
                            </v-row>
                        </div>
                        <div v-if="i === 2">
                            <v-row>
                                <v-col cols="12">
                                    <v-simple-table class="table-inv">
                                        <template v-slot:default>
                                            <thead>
                                                <tr class="col-tr-1">
                                                    <th
                                                        class="text-center"
                                                    ></th>
                                                    <th class="text-center">
                                                        #
                                                    </th>
                                                    <th class="text-center">
                                                        LMT
                                                    </th>
                                                    <th class="text-center">
                                                        Case ID
                                                    </th>
                                                    <th class="text-center">
                                                        Dete Open
                                                    </th>
                                                    <th class="text-center">
                                                        Part
                                                    </th>
                                                    <th class="text-center">
                                                        Singlepart
                                                    </th>
                                                    <th class="text-center">
                                                        Site Name
                                                    </th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr
                                                    v-for="(row,
                                                    index) in data_mainnonhp"
                                                    :key="index"
                                                >
                                                    <td class="text-center">
                                                        <v-checkbox
                                                            v-model="
                                                                checkboxnonhp
                                                            "
                                                            label=""
                                                            color="green"
                                                            :value="row"
                                                            @change="
                                                                open_dialog_ct(
                                                                    row.part_issue_id
                                                                )
                                                            "
                                                        ></v-checkbox>
                                                    </td>
                                                    <td class="text-center">
                                                        {{ index + 1 }}.
                                                    </td>
                                                    <td class="text-center">
                                                        {{ row.ship_date }}
                                                    </td>
                                                    <td class="text-center">
                                                        <v-chip
                                                            x-small
                                                            class="amber"
                                                            >{{
                                                                row.case_id +
                                                                    "-" +
                                                                    row.subcase
                                                            }}</v-chip
                                                        >
                                                        <br />
                                                        <v-chip
                                                            x-small
                                                            :color="
                                                                row.case_type !=
                                                                'Onsite Repair'
                                                                    ? 'primary'
                                                                    : ''
                                                            "
                                                            >{{
                                                                row.case_type
                                                            }}</v-chip
                                                        >
                                                    </td>
                                                    <td class="text-center">
                                                        {{ row.created_date }}
                                                    </td>

                                                    <td class="text-center">
                                                        {{ row.part_name }}
                                                    </td>
                                                    <td class="text-center">
                                                        {{ row.singlepart }}
                                                    </td>

                                                    <td>
                                                        {{ row.site_name }}
                                                        <br />
                                                        <v-chip
                                                            color="orange darken-4"
                                                            text-color="white"
                                                            x-small
                                                            v-if="
                                                                row.site_district_id
                                                            "
                                                        >
                                                            {{
                                                                row.site_district_id
                                                            }}</v-chip
                                                        >
                                                        <v-chip
                                                            class="ml-1 mr-1"
                                                            color="pink"
                                                            text-color="white"
                                                            x-small
                                                            v-if="
                                                                row.site_amphur_id
                                                            "
                                                        >
                                                            {{
                                                                row.site_amphur_id
                                                            }}</v-chip
                                                        >
                                                        <v-chip
                                                            color="purple darken-2"
                                                            text-color="white"
                                                            x-small
                                                            v-if="
                                                                row.site_province_id
                                                            "
                                                        >
                                                            {{
                                                                row.site_province_id
                                                            }}</v-chip
                                                        >
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </template>
                                    </v-simple-table>
                                    <!-- <div class="text-center pb-5 pt-4">
                    <div>
                      <v-btn class="mx-2" fab small @click="backreceive()">
                        <v-icon dark small>mdi-chevron-left</v-icon>
                      </v-btn>

                      <v-btn
                        class="mx-2"
                        fab
                        small
                        :color="btn_colorreceivepacking(n)"
                        v-for="n in page_countreceivepacking"
                        :key="n"
                        @click="
                          getpagereceivepacking(page_num_showreceivepacking(n))
                        "
                        >{{ page_num_showreceivepacking(n) }}</v-btn
                      >

                      <v-btn class="mx-2" fab small @click="nextreceive()">
                        <v-icon dark small>mdi-chevron-right</v-icon>
                      </v-btn>
                    </div>
                  </div>
                  <hr class="fix-hr-1" /> -->
                                </v-col>
                            </v-row>
                        </div>
                    </v-tab-item>
                </v-tabs-items>
            </v-tabs>
        </div>
        <!-- <template>
      <v-form method="post" id="nativeForm" v-model="valid">
        <v-row justify="center">
          <v-dialog v-model="dialog" max-width="1280px">
            <v-card>
              <v-card-title>
                <v-row>
                  <v-col cols="12" sm="4" md="2">
                    Detail Packingno :
                  </v-col>
                  <v-col cols="12" sm="3" md="2">
                    <span class="headline"
                      >{{ datashowdetailpending.packing_no }}
                    </span>
                  </v-col>
                  <v-col cols="12" sm="3" md="2">
                    <span class="headline">
                      <v-btn
                        v-if="datashowdetailpending.status != 'Received'"
                        class="ma-2"
                        :disabled="!valid"
                        @click="savereceivepartnonhp(datashowdetailpending)"
                        color="cyan"
                        style="color:white;"
                      >
                        <v-icon left color="white">mdi-content-save</v-icon>
                        Save
                      </v-btn>
                    </span>
                  </v-col>
                </v-row>
              </v-card-title>

              <v-container style="margin-top:-30px"
                ><v-row>
                  <v-col cols="12">
                    <v-simple-table class="table-inv">
                      <template v-slot:default>
                        <thead>
                          <tr class="col-tr-1 np">
                            <th class="text-center">
                              #
                            </th>
                            <th class="text-center">
                              Type
                            </th>
                            <th class="text-center">
                              CaseID
                            </th>
                            <th class="text-center">
                              Description / Serial
                            </th>
                            <th class="text-center">
                              Packing_by/ Date
                            </th>
                            <th class="text-center">
                              Qty
                            </th>
                            <th class="text-center">
                              Action
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr
                            v-for="(row,
                            index) in datashowdetailpending.packing"
                            :key="index"
                          >
                            <td class="text-center">
                              {{ index + 1 }}
                            </td>

                            <td class="text-center">
                              {{ row.type_name }}
                            </td>

                            <td class="text-center">
                              {{ row.case_id }}
                            </td>
                            <td class="text-center">
                              {{ row.description }}
                              / {{ row.serial }}
                            </td>
                            <td class="text-center">
                              {{ row.created_name }}/
                              {{ row.created_date }}
                            </td>
                            <td class="text-center">
                              {{ row.qty }}
                            </td>
                            <td
                              class="text-center"
                              v-if="datashowdetailpending.status != 'Received'"
                            >
                              <v-card-title>
                                <v-row>
                                  <v-tooltip top>
                                    <template
                                      v-slot:activator="{
                                        on,
                                        attrs,
                                      }"
                                    >
                                      <v-btn
                                        style="margin-left:10px;"
                                        @click="
                                          row.button === 1
                                            ? ((row.button = 0),
                                              (row.select = ''))
                                            : ((row.button = 1),
                                              (row.select = row.detail_id))
                                        "
                                        :color="
                                          row.button === 1 ? 'black' : 'white'
                                        "
                                        v-bind="attrs"
                                        v-on="on"
                                        fab
                                        small
                                        dark
                                      >
                                        <v-icon
                                          :color="
                                            row.button === 1 ? 'green' : 'black'
                                          "
                                          >mdi-check</v-icon
                                        >
                                      </v-btn>
                                    </template>
                                    <span>Receive</span>
                                  </v-tooltip>

                                  <v-tooltip top>
                                    <template
                                      v-slot:activator="{
                                        on,
                                        attrs,
                                      }"
                                    >
                                      <v-btn
                                        @click="
                                          row.button === 2
                                            ? ((row.button = 0),
                                              (row.select = ''))
                                            : ((row.button = 2),
                                              (row.select = row.detail_id))
                                        "
                                        style="margin-left:10px;"
                                        :color="
                                          row.button === 2 ? 'black' : 'white'
                                        "
                                        v-bind="attrs"
                                        v-on="on"
                                        fab
                                        small
                                        dark
                                      >
                                        <v-icon
                                          :color="
                                            row.button === 2 ? 'red' : 'black'
                                          "
                                          >mdi-close-thick</v-icon
                                        >
                                      </v-btn>
                                    </template>
                                    <span>Not Receive</span>
                                  </v-tooltip>
                                  <div
                                    style="margin-top:10px"
                                    v-if="row.button === 2"
                                  >
                                    <v-text-field
                                      label="Reason"
                                      v-model="row.remark"
                                      :rules="reasonR"
                                      required
                                      outlined
                                    ></v-text-field>
                                  </div>
                                </v-row>
                              </v-card-title>
                            </td>
                            <td v-else class="text-center">
                              Received
                            </td>
                          </tr>
                        </tbody>
                      </template>
                    </v-simple-table>
                    <hr class="fix-hr-1" />
                  </v-col>
                </v-row>
              </v-container>
            </v-card>
          </v-dialog>
        </v-row>
      </v-form>
    </template> -->

        <template>
            <v-row justify="center">
                <v-dialog v-model="dialog_part_hp" width="960px">
                    <v-card>
                        <v-card-title>
                            <span class="headline"
                                >Receive Part - HP :
                                {{ checkbox.length }} Part</span
                            >
                        </v-card-title>
                        <v-card-text>
                            <v-row>
                                <v-col cols="12">
                                    <v-simple-table class="table-inv">
                                        <template v-slot:default>
                                            <thead>
                                                <tr class="col-tr-1">
                                                    <th class="text-center">
                                                        #
                                                    </th>
                                                    <th class="text-center">
                                                        CaseID-Sub
                                                    </th>
                                                    <th class="text-center">
                                                        PO Number
                                                    </th>
                                                    <th class="text-center">
                                                        Part
                                                    </th>
                                                    <th class="text-centet">
                                                        Case Type
                                                    </th>
                                                    <th class="text-center">
                                                        Dete
                                                    </th>
                                                    <th class="text-center">
                                                        Province
                                                    </th>
                                                    <th class="text-center">
                                                        LMT
                                                    </th>
                                                    <th class="text-center">
                                                        CT NEW
                                                    </th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr
                                                    v-for="(row,
                                                    index) in checkbox"
                                                    :key="index"
                                                >
                                                    <td class="text-center">
                                                        {{ index + 1 }}.
                                                    </td>
                                                    <td class="text-center">
                                                        {{
                                                            row.case_id +
                                                                "-" +
                                                                row.subcase
                                                        }}
                                                    </td>
                                                    <td class="text-center">
                                                        {{ row.ponumber }}
                                                    </td>
                                                    <td class="text-center">
                                                        {{ row.part_name }}
                                                    </td>
                                                    <td>{{ row.case_type }}</td>
                                                    <td class="text-center">
                                                        {{ row.created_date }}
                                                    </td>
                                                    <td>
                                                        {{
                                                            row.province_name_en
                                                        }}
                                                    </td>

                                                    <td class="text-center">
                                                        {{ row.ship_date }}
                                                    </td>
                                                    <td class="text-center">
                                                        <v-icon
                                                            color="success"
                                                            v-if="
                                                                row.ct_new !=
                                                                    null &&
                                                                    row.ct_new !=
                                                                        ''
                                                            "
                                                        >
                                                            mdi-checkbox-marked-circle
                                                        </v-icon>
                                                        <v-icon
                                                            color="red"
                                                            v-if="
                                                                row.ct_new ===
                                                                    null ||
                                                                    row.ct_new ===
                                                                        ''
                                                            "
                                                        >
                                                            mdi-close-circle
                                                        </v-icon>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </template>
                                    </v-simple-table>
                                    <hr class="fix-hr-1" />
                                </v-col>
                            </v-row>
                        </v-card-text>
                        <v-card-actions>
                            <v-btn
                                text
                                rounded
                                small
                                @click="dialog_part_hp = false"
                                >Close</v-btn
                            >
                            <v-spacer></v-spacer>
                            <v-btn
                                color="success"
                                small
                                rounded
                                @click="receive_part(actibe_tab)"
                                ><v-icon small class="mr-1"
                                    >mdi-content-save</v-icon
                                >
                                Save</v-btn
                            >
                        </v-card-actions>
                    </v-card>
                </v-dialog>
            </v-row>
        </template>
        <template>
            <v-row justify="center">
                <v-dialog v-model="dialog_part_nonhp" width="960px">
                    <v-card>
                        <v-card-title>
                            <span class="headline"
                                >Receive Part - NON HP :
                                {{ checkboxnonhp.length }} Part</span
                            >
                        </v-card-title>
                        <v-card-text>
                            <v-row>
                                <v-col cols="12">
                                    <v-simple-table class="table-inv">
                                        <template v-slot:default>
                                            <thead>
                                                <tr class="col-tr-1">
                                                    <th class="text-center">
                                                        #
                                                    </th>
                                                    <th class="text-center">
                                                        CaseID-Sub
                                                    </th>
                                                    <th class="text-center">
                                                        PO Number
                                                    </th>
                                                    <th class="text-center">
                                                        Part
                                                    </th>
                                                    <th class="text-centet">
                                                        Case Type
                                                    </th>
                                                    <th class="text-center">
                                                        Dete
                                                    </th>
                                                    <th class="text-center">
                                                        Province
                                                    </th>
                                                    <th class="text-center">
                                                        LMT
                                                    </th>
                                                    <th class="text-center">
                                                        CT NEW
                                                    </th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr
                                                    v-for="(row,
                                                    index) in checkboxnonhp"
                                                    :key="index"
                                                >
                                                    <td class="text-center">
                                                        {{ index + 1 }}.
                                                    </td>
                                                    <td class="text-center">
                                                        {{
                                                            row.case_id +
                                                                "-" +
                                                                row.subcase
                                                        }}
                                                    </td>
                                                    <td class="text-center">
                                                        {{ row.ponumber }}
                                                    </td>
                                                    <td class="text-center">
                                                        {{ row.part_name }}
                                                    </td>
                                                    <td>{{ row.case_type }}</td>
                                                    <td class="text-center">
                                                        {{ row.created_date }}
                                                    </td>
                                                    <td>
                                                        {{
                                                            row.province_name_en
                                                        }}
                                                    </td>

                                                    <td class="text-center">
                                                        {{ row.ship_date }}
                                                    </td>
                                                    <td class="text-center">
                                                        <v-icon
                                                            color="success"
                                                            v-if="
                                                                row.ct_new !=
                                                                    null
                                                            "
                                                        >
                                                            mdi-checkbox-marked-circle
                                                        </v-icon>
                                                        <v-icon
                                                            color="red"
                                                            v-if="
                                                                row.ct_new ===
                                                                    null ||
                                                                    row.ct_new ===
                                                                        ''
                                                            "
                                                        >
                                                            mdi-close-circle
                                                        </v-icon>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </template>
                                    </v-simple-table>
                                    <hr class="fix-hr-1" />
                                </v-col>
                            </v-row>
                        </v-card-text>
                        <v-card-actions>
                            <v-btn
                                text
                                rounded
                                small
                                @click="dialog_part_nonhp = false"
                                >Close</v-btn
                            >
                            <v-spacer></v-spacer>
                            <v-btn
                                color="success"
                                small
                                rounded
                                @click="receive_part(actibe_tab)"
                                ><v-icon small class="mr-1"
                                    >mdi-content-save</v-icon
                                >
                                Save</v-btn
                            >
                        </v-card-actions>
                    </v-card>
                </v-dialog>
            </v-row>
        </template>
        <template>
            <v-row justify="center">
                <v-dialog v-model="dialog_ct" max-width="290" persistent>
                    <v-card>
                        <v-card-title class="headline">CT NEW</v-card-title>

                        <v-card-text>
                            <v-row v-if="chk_parts.length > 0">
                                <!-- this.chk_parts -->
                                <v-col
                                    cols="12"
                                    v-for="(r_p, i_p) in chk_parts"
                                    :key="i_p"
                                >
                                    <v-chip small class="amber">{{
                                        r_p.part_name
                                    }}</v-chip>
                                    <v-text-field
                                        v-model="r_p.ct_new"
                                        label="CT NEW"
                                    ></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row v-else>
                                <v-col cols="12">
                                    <v-text-field
                                        v-model="data_ct.ct_new"
                                        label="CT NEW"
                                    ></v-text-field>
                                </v-col>
                            </v-row>
                        </v-card-text>

                        <v-card-actions>
                            <v-btn
                                color="green darken-1"
                                text
                                @click="close_skip()"
                            >
                                Skip CT
                            </v-btn>
                            <v-spacer></v-spacer>

                            <v-btn
                                color="success"
                                small
                                rounded
                                @click="save_ct_new()"
                                ><v-icon small class="mr-1"
                                    >mdi-content-save</v-icon
                                >
                                Save</v-btn
                            >
                        </v-card-actions>
                    </v-card>
                </v-dialog>
            </v-row>
        </template>
        <v-row justify="center">
            <v-dialog
                v-model="dialog_search"
                fullscreen
                hide-overlay
                transition="dialog-bottom-transition"
            >
                <v-card>
                    <v-toolbar dark color="primary">
                        <v-btn icon dark @click="dialog_search = false">
                            <v-icon>mdi-close</v-icon>
                        </v-btn>
                        <v-toolbar-title>
                            <!-- Settings -->
                        </v-toolbar-title>
                        <v-spacer></v-spacer>
                        <!-- <v-toolbar-items>
                            <v-btn dark text @click="dialog = false"
                                >Save</v-btn
                            >
                        </v-toolbar-items> -->
                    </v-toolbar>
                    <v-list three-line subheader>
                        <v-list-item>
                            <v-list-item-content>
                                <v-row>
                                    <v-col cols="3">
                                        <v-text-field
                                            label="Search"
                                            v-model="data_search.search"
                                            prepend-inner-icon="mdi-magnify"
                                            dense
                                        ></v-text-field>
                                    </v-col>
                                    <v-col cols="3">
                                        <v-menu
                                            v-model="modal"
                                            :close-on-content-click="false"
                                            :nudge-right="40"
                                            transition="scale-transition"
                                            offset-y
                                        >
                                            <template v-slot:activator="{ on }">
                                                <v-text-field
                                                    v-model="dateRangeText"
                                                    label="Date range"
                                                    dense
                                                    prepend-inner-icon="mdi-calendar"
                                                    readonly
                                                    v-on="on"
                                                ></v-text-field>
                                            </template>
                                            <v-date-picker
                                                v-model="data_search.date"
                                                range
                                                @change="get_date()"
                                            ></v-date-picker>
                                        </v-menu>
                                    </v-col>
                                    <v-col
                                        cols="1"
                                        class="text-right"
                                        v-if="checkbox.length == 0"
                                    >
                                        <v-btn
                                            rounded
                                            small
                                            class="ml-5"
                                            @click="get_history()"
                                        >
                                            <v-icon small class="mr-1">
                                                mdi-magnify
                                            </v-icon>
                                            Search
                                        </v-btn>
                                    </v-col>
                                </v-row>

                                <v-row>
                                    <v-col cols="12">
                                        <v-simple-table class="table-inv">
                                            <template v-slot:default>
                                                <thead>
                                                    <tr class="col-tr-1">
                                                        <th class="text-center">
                                                            #
                                                        </th>
                                                        <th class="text-center">
                                                            LMT
                                                        </th>
                                                        <th class="text-center">
                                                            Case ID
                                                        </th>
                                                        <th class="text-center">
                                                            Product Serial
                                                        </th>
                                                        <th class="text-center">
                                                            Dete Open
                                                        </th>
                                                        <th class="text-center">
                                                            PO Number
                                                        </th>
                                                        <th class="text-center">
                                                            Part
                                                        </th>
                                                        <th class="text-center">
                                                            RMA
                                                        </th>

                                                        <th class="text-center">
                                                            Site Name
                                                        </th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr
                                                        v-for="(row,
                                                        index) in data_history"
                                                        :key="index"
                                                    >
                                                        <td class="text-center">
                                                            {{ index + 1 }}.
                                                        </td>
                                                        <td class="text-center">
                                                            {{ row.ship_date }}
                                                        </td>
                                                        <td class="text-center">
                                                            <v-chip
                                                                x-small
                                                                class="amber"
                                                                >{{
                                                                    row.case_id +
                                                                        "-" +
                                                                        row.subcase
                                                                }}</v-chip
                                                            >
                                                            <br />
                                                            <v-chip
                                                                x-small
                                                                :color="
                                                                    row.case_type !=
                                                                    'Onsite Repair'
                                                                        ? 'primary'
                                                                        : ''
                                                                "
                                                                >{{
                                                                    row.case_type
                                                                }}</v-chip
                                                            >
                                                        </td>
                                                        <td class="text-left">
                                                            {{
                                                                row.product_serial
                                                            }}
                                                        </td>
                                                        <td class="text-center">
                                                            {{
                                                                row.created_date
                                                            }}
                                                        </td>
                                                        <td class="text-center">
                                                            {{ row.ponumber }}
                                                        </td>
                                                        <td class="text-center">
                                                            {{ row.part_name }}
                                                        </td>
                                                        <td class="text-center">
                                                            <span
                                                                v-if="row.rma"
                                                                >{{
                                                                    row.rma
                                                                }}</span
                                                            >
                                                            <span
                                                                v-if="
                                                                    row.singlepart
                                                                "
                                                                >{{
                                                                    row.singlepart
                                                                }}</span
                                                            >
                                                        </td>

                                                        <td>
                                                            {{ row.site_name }}
                                                            <br />
                                                            <v-chip
                                                                color="orange darken-4"
                                                                text-color="white"
                                                                x-small
                                                                v-if="
                                                                    row.site_district_id
                                                                "
                                                            >
                                                                {{
                                                                    row.site_district_id
                                                                }}</v-chip
                                                            >
                                                            <v-chip
                                                                class="ml-1 mr-1"
                                                                color="pink"
                                                                text-color="white"
                                                                x-small
                                                                v-if="
                                                                    row.site_amphur_id
                                                                "
                                                            >
                                                                {{
                                                                    row.site_amphur_id
                                                                }}</v-chip
                                                            >
                                                            <v-chip
                                                                color="purple darken-2"
                                                                text-color="white"
                                                                x-small
                                                                v-if="
                                                                    row.site_province_id
                                                                "
                                                            >
                                                                {{
                                                                    row.site_province_id
                                                                }}</v-chip
                                                            >
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </template>
                                        </v-simple-table>
                                    </v-col>
                                </v-row>
                            </v-list-item-content>
                        </v-list-item>
                    </v-list>
                </v-card>
            </v-dialog>
        </v-row>

        <v-dialog v-model="dialog_loading" hide-overlay persistent width="320">
            <v-card color="primary" dark>
                <v-card-text>
                    <span class="mt-1 white--text">Loading</span>
                    <v-progress-linear
                        indeterminate
                        color="white"
                        class="mb-0"
                    ></v-progress-linear>
                </v-card-text>
            </v-card>
        </v-dialog>
    </div>
</template>
<script>
import _ from "lodash"
import axios from "axios"
import { mapState, mapMutations } from "vuex"
import BarcodeReader from "../../../components/BarcodeReader"

let url = `${process.env.VUE_APP_ROOT_API}/api/`
export default {
    components: { BarcodeReader },
    beforeMount() {
        this.tk = {
            headers: { Authorization: "Bearer " + localStorage.token },
        }

        if (
            this.team_name === "IPG" ||
            this.team_name === "PSG" ||
            this.team_name === "ODM"
        ) {
            this.tabs_name = ["HP"]
        } else {
            this.tabs_name = ["HP", "NONHP"]
        }
    },
    mounted() {
        this.get_data()
    },
    created() {
        this.receive_part = _.debounce(this.receive_part, 1500)
        this.change_search = _.debounce(this.change_search, 1000)
    },
    computed: {
        ...mapState(["isLoading"]),
        // ...mapState(["snackbar"]),
        dateRangeText() {
            this.data_search.date.sort((a, b) => {
                return new Date(a) - new Date(b)
            })

            return this.data_search.date.join(" ~ ")
        },
    },
    // watch: {
    //     textsearch: function(val) {
    //         console.log(val)
    //         this.textsearch = val
    //     },
    // },
    // beforeUpdate() {
    //     console.log("beforeUpdate() val: " + this.val)
    // },
    // updated() {
    //     console.log("updated() val: " + this.val)
    // },
    methods: {
        ...mapMutations(["mutateIsLoading"]),
        async getpagereceivepacking(num) {
            const options = {
                headers: {
                    Authorization: "Bearer " + localStorage.token,
                },
            }
            if (num != "...") {
                this.current_page = num
                let url =
                    `${process.env.VUE_APP_ROOT_API}/api/logistics/packinglist/view-pending?page=` +
                    num
                let { data } = await axios.post(url, {}, options)
                this.dataviewpending = data
            }
        },
        page_num_showreceivepacking(n) {
            let page = n
            if (this.page_countreceivepacking == 7) {
                let chk2 = 0
                let chk3 = 0
                let chk4 = 0
                let chk5 = 0
                let chk6 = 0
                if (this.dataviewpending.current_page == 1) {
                    chk2 = 2
                    chk3 = 3
                    chk4 = 4
                    chk5 = "..."
                    chk6 = this.dataviewpending.last_page - 1
                } else if (
                    this.dataviewpending.current_page ==
                    this.dataviewpending.last_page
                ) {
                    chk2 = 2
                    chk3 = "..."
                    chk4 = this.dataviewpending.last_page - 3
                    chk5 = this.dataviewpending.last_page - 2
                    chk6 = this.dataviewpending.last_page - 1
                } else if (this.dataviewpending.current_page == 2) {
                    chk2 = 2
                    chk3 = 3
                    chk4 = 4
                    chk5 = "..."
                    chk6 = this.dataviewpending.last_page - 1
                } else if (
                    this.dataviewpending.current_page ==
                    this.dataviewpending.last_page - 1
                ) {
                    chk2 = 2
                    chk3 = "..."
                    chk4 = this.dataviewpending.last_page - 3
                    chk5 = this.dataviewpending.last_page - 2
                    chk6 = this.dataviewpending.last_page - 1
                } else if (this.dataviewpending.current_page == 3) {
                    chk2 = 2
                    chk3 = 3
                    chk4 = 4
                    chk5 = "..."
                    chk6 = this.dataviewpending.last_page - 1
                } else if (
                    this.dataviewpending.current_page ==
                    this.dataviewpending.last_page - 2
                ) {
                    chk2 = 2
                    chk3 = "..."
                    chk4 = this.dataviewpending.last_page - 3
                    chk5 = this.dataviewpending.last_page - 2
                    chk6 = this.dataviewpending.last_page - 1
                } else {
                    chk2 = "..."
                    chk3 = this.dataviewpending.current_page - 1
                    chk4 = this.dataviewpending.current_page
                    chk5 = this.dataviewpending.current_page + 1
                    chk6 = "..."
                }

                n === 1 ? (page = 1) : ""
                n === 2 ? (page = chk2) : ""
                n === 3 ? (page = chk3) : ""
                n === 4 ? (page = chk4) : ""
                n === 5 ? (page = chk5) : ""
                n === 6 ? (page = chk6) : ""
                n === 7 ? (page = this.dataviewpending.last_page) : ""
            } else {
                n === 1 ? (page = 1) : ""
                n === 2 ? (page = 2) : ""
                n === 3 ? (page = 3) : ""
                n === 4 ? (page = 4) : ""
                n === 5 ? (page = 5) : ""
                n === 6 ? (page = 6) : ""
            }
            return page
        },
        btn_colorreceivepacking(n) {
            if (this.page_countreceivepacking == 7) {
                if (this.dataviewpending.current_page <= 4) {
                    return this.dataviewpending.current_page === n
                        ? "primary"
                        : ""
                } else if (
                    this.dataviewpending.current_page ==
                    this.dataviewpending.last_page
                ) {
                    return n === 7 ? "primary" : ""
                } else if (
                    this.dataviewpending.current_page ==
                    this.dataviewpending.last_page - 1
                ) {
                    return n === 6 ? "primary" : ""
                } else if (
                    this.dataviewpending.current_page ==
                    this.dataviewpending.last_page - 2
                ) {
                    return n === 5 ? "primary" : ""
                } else {
                    return n === 4 ? "primary" : ""
                }
            } else {
                return this.dataviewpending.current_page === n ? "primary" : ""
            }
        },
        // ...mapMutations(["mutatesnackbar"]),
        // async savereceivepartnonhp(items) {
        //     const options = {
        //         headers: {
        //             Authorization: "Bearer " + localStorage.token,
        //         },
        //     }
        //     for (let i = 0; i < items.packing.length; i++) {
        //         if (
        //             items.packing[i].button == "" ||
        //             items.packing[i].button == undefined ||
        //             items.packing[i].button == null
        //         ) {
        //             this.$swal(
        //                 "กรุณาเลือกปุ่ม Receive หรือ NotReceive ",
        //                 "Please Select Receive or NotReceive",
        //                 "info"
        //             )
        //             exit()
        //         }
        //     }

        //     var status = ""
        //     this.datasavereceive = []
        //     items.packing.map((each) => {
        //         if (each.button == 1) {
        //             status = "receive"
        //         } else if (each.button == 2) {
        //             status = "not_receive"
        //         }

        //         var sent = {
        //             detail_id: each.select,
        //             status: status,
        //             remark: each.remark,
        //         }
        //         // var packing = {
        //         //   packing: sent,
        //         // };

        //         this.datasavereceive.push(sent)

        //         var status = ""
        //     })
        //     this.mutateIsLoading()
        //     const url = `${process.env.VUE_APP_ROOT_API}/api/logistics/packinglist/receive`
        //     try {
        //         const { data } = await axios.post(
        //             url + "/" + this.packingno,
        //             { packing: this.datasavereceive },
        //             options
        //         )
        //         this.dialog = false
        //         this.mutateIsLoading()
        //         this.getviewpending()
        //     } catch (error) {
        //         console.log(error)
        //     }
        // },

        showdetailpending(items) {
            this.dialog = true
            this.packingno = items.packing[0].packing_no

            this.datashowdetailpending = items
        },
        async get_data() {
            // this.mutateIsLoading()
            this.dialog_loading = true
            let send_data = {
                textsearch: this.textsearch,
            }
            await axios
                .post(url + "engineer/receive-part/", send_data, this.tk)
                .then((response) => {
                    this.dialog_part_hp = false
                    this.textsearch = ""
                    this.checkbox = []
                    this.chk = true
                    this.colorx = ""
                    this.data_main = []
                    this.data_main = response.data
                    // this.mutateIsLoading()
                    this.dialog_loading = false
                })
                .catch((error) => {
                    this.mutateIsLoading()
                    console.log(error)
                })
        },
        async get_datanonhp() {
            // this.mutateIsLoading()
            this.dialog_loading = true
            let send_data = {
                textsearch: this.textsearch,
            }
            await axios
                .post(url + "engineer/receive-part-nonhp/", send_data, this.tk)
                .then((response) => {
                    this.dialog_part_nonhp = false
                    this.textsearch = ""
                    this.checkboxnonhp = []
                    this.chknonhp = true
                    this.colorxnonhp = ""

                    this.data_mainnonhp = response.data
                    // this.mutateIsLoading()
                    this.dialog_loading = false
                })
                .catch((error) => {
                    this.mutateIsLoading()
                    console.log(error)
                })
        },
        // async getviewpending() {
        //   this.mutateIsLoading();
        //   const options = {
        //     headers: {
        //       Authorization: "Bearer " + localStorage.token,
        //     },
        //   };
        //   const url = `${process.env.VUE_APP_ROOT_API}/api/logistics/packinglist/view-pending`;
        //   try {
        //     const { data } = await axios.post(
        //       url,
        //       { searchtext: this.textsearch },
        //       options
        //     );
        //     this.mutateIsLoading();
        //     this.dataviewpending = data;
        //     // console.log(this.dataviewpending, "gfg");
        //     this.page_totalreceivepacking = data.last_page;
        //     this.page_totalreceivepacking < 7
        //       ? (this.page_countreceivepacking = this.page_totalreceivepacking)
        //       : (this.page_countreceivepacking = 7);
        //   } catch (error) {
        //     console.log(error);
        //   }
        // },
        async receive_part(tab) {
            // this.mutateIsLoading()
            this.dialog_loading = true

            let data_save = {
                array_parts: "",
            }

            if (tab == "HP") {
                // this.checkbox.map((r, i) => {
                //     let str
                //     if (r.sms_language == "th") {
                //         str = `งานซ่อมหมายเลข ${r.case_id} พร้อมให้บริการแล้ว คุณ<<FE_firstname_EN>> จะเป็นช่างให้คุณในวันนี้ สอบถามข้อมูลเพิ่มเติมได้ที่ 020781589`
                //     } else if (r.sms_language == "en") {
                //         str = `Case no: ${r.case_id} is now ready for service. HP Technician <<FE_firstname_EN>> will be assisting you today. For more information, please call 020781589`
                //     }
                //     str = str
                //         .split("")
                //         .map((char) =>
                //             addZeros(char.charCodeAt(0).toString(16))
                //         )
                //         .join("")
                //     function addZeros(str) {
                //         return ("0000" + str).slice(-4)
                //     }
                //     r.str = str
                // })
                data_save.array_parts = this.checkbox
            } else {
                data_save.array_parts = this.checkboxnonhp
            }

            console.log(data_save, "-data_save")
            await axios
                .post(url + "engineer/receive-part/save", data_save, this.tk)
                .then((response) => {
                    // this.mutateIsLoading()
                    this.dialog_loading = false
                    if (tab == "HP") {
                        this.get_data()
                    } else {
                        this.get_datanonhp()
                    }
                    this.$swal({
                        title: "Successful Receive Part",
                        text: "กดรับ Part เรียบร้อย",
                        icon: "success",
                        button: false,
                        timer: 2000,
                    })
                })
                .catch((error) => {
                    console.log(error)
                })
        },

        async gen_barcode(result) {
            this.textsearch = result
            let no = 0
            this.data_main.map((r) => {
                if (r.rma === this.textsearch.substr(0, 16)) {
                    this.checkbox.push(r)
                    no += 1
                }
            })

            // if (no > 0) {
            //     this.$swal({
            //         title: "Successful Receive Part",
            //         text: "กดรับ Part เรียบร้อย",
            //         icon: "success",
            //         button: false,
            //         timer: 2000,
            //     })
            // }

            if (no === 0) {
                this.$swal({
                    title: this.textsearch,
                    text: "ค้นหาพาร์ทเลขนี้ไม่เจอในระบ",
                    icon: "warning",
                    button: false,
                    timer: 2000,
                })
            }
        },
        change_search() {
            if (this.actibe_tab == "NONHP") {
                // this.getviewpending()
                let no = 0
                this.data_mainnonhp.map((r, i) => {
                    if (
                        r.singlepart === this.textsearch ||
                        r.case_id === this.textsearch
                    ) {
                        this.data_ct.part_issue_id = r.part_issue_id

                        this.checkboxnonhp.push(r)

                        no += 1
                        // if (
                        //     (row.project_name == "CDAX" ||
                        //         row.project_name == "ODM") &&
                        //     row.product_group == "Computing" &&
                        //     row.product_line != "BO"
                        // ) {
                        //     this.chk_parts.push(row)
                        //     this.dialog_ct = true
                        // }
                    }
                })

                if (no > 0) {
                    this.open_dialog_ct(this.data_ct.part_issue_id)
                    this.textsearch = ""
                }

                if (no === 0) {
                    this.$swal({
                        title: this.textsearch,
                        text: "ค้นหาพาร์ทเลขนี้ไม่เจอในระบ",
                        icon: "warning",
                        button: false,
                        timer: 2000,
                    })
                }
            } else {
                let no = 0
                this.data_main.map((r, i) => {
                    r.parts.map((row, index) => {
                        if (
                            row.rma === this.textsearch ||
                            row.ponumber === this.textsearch ||
                            row.case_id === this.textsearch
                        ) {
                            this.data_ct.part_issue_id = row.part_issue_id

                            this.checkbox.push(row)

                            no += 1
                            if (
                                (row.project_name == "CDAX" ||
                                    row.project_name == "ODM") &&
                                row.product_group == "Computing" &&
                                row.product_line != "BO"
                            ) {
                                this.chk_parts.push(row)
                                this.dialog_ct = true
                            }
                        }
                    })
                })

                if (no > 0) {
                    this.open_dialog_ct(this.data_ct.part_issue_id)
                    this.textsearch = ""
                }

                if (no === 0) {
                    this.$swal({
                        title: this.textsearch,
                        text: "ค้นหาพาร์ทเลขนี้ไม่เจอในระบ",
                        icon: "warning",
                        button: false,
                        timer: 2000,
                    })
                }
            }
        },
        async reset() {
            this.textsearch = ""
        },
        change_tab(change_tab) {
            this.chk = false
            this.actibe_tab = change_tab

            if (change_tab === "NONHP") {
                this.get_datanonhp()
            }
        },
        all() {
            if (this.chk === true) {
                this.chk = false
                this.colorx = ""
                this.checkbox = []
            } else {
                this.chk = true
                this.colorx = "success"
                this.checkbox = this.data_main
            }
        },
        open_dialog_ct(
            part_issue_idx,
            project_name,
            product_group,
            product_line
        ) {
            this.checkbox.map((r, i) => {
                if (
                    r.part_issue_id === part_issue_idx &&
                    (project_name == "CDAX" || project_name == "ODM") &&
                    product_group == "Computing" &&
                    product_line != "BO"
                ) {
                    this.dialog_ct = true
                }
                if (
                    r.part_issue_id === this.data_ct.part_issue_id ||
                    r.rma === this.textsearch ||
                    r.ponumber === this.textsearch ||
                    r.case_id === this.textsearch
                ) {
                    this.data_ct.ct_new = r.ct_new
                } else {
                    this.data_ct.part_issue_id = part_issue_idx
                }
            })
        },
        get_dialog_part(tab) {
            if (tab == "HP") {
                this.dialog_part_hp = true
            } else {
                this.dialog_part_nonhp = true
            }
        },
        save_ct_new() {
            if (this.chk_parts.length == 0) {
                this.checkbox.map((r, i) => {
                    if (r.part_issue_id === this.data_ct.part_issue_id) {
                        this.checkbox[i].ct_new = this.data_ct.ct_new
                    }
                })
            }
            this.data_ct.ct_new = null
            this.data_ct.part_issue_id = null
            this.dialog_ct = false
            this.chk_parts = []
        },
        get_date() {
            if (this.dateRangeText.length === 23) {
                this.modal = false
            }
        },
        async get_history() {
            this.mutateIsLoading()
            this.dialog_loading = true
            await axios
                .post(
                    url + "engineer/receive-part/history",
                    this.data_search,
                    this.tk
                )
                .then((response) => {
                    this.data_history = response.data
                    // this.mutateIsLoading()
                    this.dialog_loading = false
                    if (this.dialog_search === false) {
                        this.dialog_search = true
                    }
                })
                .catch((error) => {
                    console.log(error)
                    this.mutateIsLoading()
                })
        },
        close_skip() {
            this.chk_parts = []
            this.dialog_ct = false
        },
    },
    data() {
        return {
            dialog_loading: false,
            page_totalreceivepacking: 0,
            page_countreceivepacking: 0,
            datasavereceive: [],
            tab: null,
            reasonR: [(v) => !!v || "Reason is required"],
            valid: false,
            selectbutton: 0,
            datashowdetailpending: [],
            dialog: false,
            dialog_part_hp: false,
            dialog_part_nonhp: false,
            dataviewpending: [],
            packingno: "",
            data_main: [],
            data_mainnonhp: [],
            tk: "",
            textsearch: "",
            chk_action: false,
            actibe_tab: "HP",
            tabs_name: [],
            direction: "right",
            checkbox: [],
            checkboxnonhp: [],
            colorx: "",
            colorxnonhp: "",
            chk: false,
            chknonhp: false,
            dialog_ct: false,
            data_ct: {
                part_issue_id: null,
                ct_new: null,
            },
            team_name: localStorage.team_name,
            dialog_search: false,
            data_search: {
                search: null,
                date: [],
            },
            modal: false,
            data_history: [],
            chk_parts: [],
        }
    },
}
</script>
